import { isEqual, isNullOrBlank, OptionsGet, optionsGetDefault, toJson } from '../../Commons';
import { FundHoldingEntity } from '../../Entities/Fund.Holding.Entity';
import { SmartDBApi } from '../index.exports';
import { fetchWrapper } from '../../lib/index.exports';

export class FundHoldingApi extends SmartDBApi {
    protected static _Entity = FundHoldingEntity;

    // #region api

    public static async getByFundHoldingPolicyID_CSApiT<T extends FundHoldingEntity>(fundHoldingPolicyID_CS: string, optionsGet?: OptionsGet): Promise<T[]> {
        try {
            if (isNullOrBlank(fundHoldingPolicyID_CS)) {
                throw `fundPolicy_CS not defined`;
            }
            //-------------------------
            let response;
            if (isEqual(optionsGet, optionsGetDefault)) {
                response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/by-CS/${fundHoldingPolicyID_CS}`);
            } else {
                const body = toJson(optionsGet);
                //-------------------------
                response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/by-CS/${fundHoldingPolicyID_CS}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //-------------------------
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${this._Entity.className()}] - getByFundHoldingPolicyID_CSApi - response OK`);
                const instances = datas.map((data: any) => this._Entity.fromPlainObject<T>(data));
                console.log(`[${this._Entity.className()}] - getByFundHoldingPolicyID_CSApi - fundHoldingPolicyID_CS: ${fundHoldingPolicyID_CS} - len: ${instances.length}`);
                return instances;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        } catch (error) {
            console.log(`[${this._Entity.className()}] - getByFundHoldingEntityPolicyID_CSApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api
}
